import makeStyles from '@mui/styles/makeStyles';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
`;
Container.displayName = 'Container';

export const CategoryContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;
CategoryContainer.displayName = 'CategoryContainer';

export const useStyles = makeStyles((theme) => ({
  header: {
    alignItems: 'flex-end',
    display: 'flex',
  },
  icon: {
    marginBottom: theme.spacing(0.5),
  },
  subtitle: {
    margin: theme.spacing(0, 0.5, 0.75, 2),
  },
  subtitleContainer: {
    alignItems: 'flex-end',
    display: 'flex',
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
}));
